export {
    searchUser,
    getCoachApplications,
    updateCoachApplication,
    upgradeStudent,
    overrideStudent,
    evaluateStudent,
    modifyCollege,
    deleteCoach,
    addCoach,
    getCoachesFromColleges,
    addCollegeToDB,
    getStudentForStudentExplorer,
    deleteCoachApplication,
    resetStudentDashboard,
} from './services';



// WEBPACK FOOTER //
// ./src/common/services/admin.services/index.js